/** Hook de menú: carga los items desde localStorage cifrado o del endpoint GETMenuItems, deriva los módulos y restaura el último módulo activo. */
import { useEffect } from "react";
import { useAuthStore } from "@/stores/authStore";
import { useUIStore } from "@/stores/uiStore";
import { GETMenuItems } from "@/api";
import { MenuItem, Module } from "@/types";
import { getFromStorage } from "@/utils";

const MENU_STORAGE_KEY = "innerwork-menu";
const MODULES_STORAGE_KEY = "innerwork-modules";

export const useMenu = () => {
  const loggedUserInnerwork = useAuthStore((s) => s.loggedUserInnerwork);
  const { itemsMenu, setItemsMenu, setModules, setCurrentModule, setMenuReady } = useUIStore();

  useEffect(() => {
    if (!loggedUserInnerwork || Object.keys(loggedUserInnerwork).length === 0) return;

    const fetchMenu = async () => {
      try {
        if (itemsMenu.length > 0) return;

        const savedItems = await getFromStorage<MenuItem[]>(MENU_STORAGE_KEY);
        const savedModules = await getFromStorage<Module[]>(MODULES_STORAGE_KEY);

        if (savedItems && savedItems.length > 0 && savedModules && savedModules.length > 0) {
          setItemsMenu(savedItems);
          setModules(savedModules);

          const savedModule = await getFromStorage<number>("lastModule");
          const targetModule =
            savedModule != null && savedModules.some((m) => m.value === savedModule)
              ? savedModule
              : savedModules[0]?.value;
          setCurrentModule(targetModule);
          return;
        }

        const { success, data } = await GETMenuItems(loggedUserInnerwork);
        if (success) {
          const items = data as MenuItem[];
          setItemsMenu(items);

          const unique: Record<string, { nombreModulo: string; ordenModulo: number }> = {};
          items.forEach((item) => {
            if (!unique[item.idModulo]) {
              unique[item.idModulo] = {
                nombreModulo: item.nombreModulo,
                ordenModulo: item.ordenModulo || 0,
              };
            }
          });

          const mods: Module[] = Object.keys(unique).map((id) => ({
            value: Number(id),
            label: unique[id].nombreModulo,
            ordenModulo: unique[id].ordenModulo,
          }));
          mods.sort((a, b) => a.ordenModulo - b.ordenModulo);
          setModules(mods);

          const savedModule = await getFromStorage<number>("lastModule");
          const targetModule =
            savedModule != null && mods.some((m) => m.value === savedModule)
              ? savedModule
              : mods[0]?.value;
          setCurrentModule(targetModule);
        }
      } finally {
        setMenuReady(true);
      }
    };

    fetchMenu();
  }, [loggedUserInnerwork]);
};
